import { useAuthContext } from '@/Auth/Context';
import { PermissionType } from '@/Auth/types';

import { isUserAuthorized } from './isUserAuthorized';
import type { IAuthorizationProps } from './types';

export function useAuthorization(props: IAuthorizationProps): PermissionType {
  const { hasInitializedUser, currentUser } = useAuthContext();
  const { allowedRoles, requiredPermissions, signedOutUserIsAllowed } = props;

  if (hasInitializedUser) {
    const userIsAuthorized = isUserAuthorized(currentUser, {
      allowedRoles,
      requiredPermissions,
      signedOutUserIsAllowed,
    });
    return userIsAuthorized ? PermissionType.ALLOWED : PermissionType.NOT_ALLOWED;
  }
  return PermissionType.UNKNOWN;
}
